import React, { useState } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import { useNavigate } from 'react-router-dom';
import { BASE_URL, BASE_URL1 } from './Constants.js';
import { Spinner } from 'react-bootstrap';

let debounceTimeout;

const BackendPaymentUpdate = () => {
  const [dateTime, setDateTime] = useState('');
  const [formData, setFormData] = useState({
  id: '',
  name: '',
  mobile: '',
  utr_number: '',
  remarks: '',
  image: null,
});
  const [dressList, setDressList] = useState([]);
  const [formError, setFormError] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleDateTimeChange = (e) => {
  setDateTime(e.target.value);
  console.log("Selected DateTime:", e.target.value); // e.g., "2025-09-12T15:45"
};

  const fetchEmployeeDetails = async (empId) => {
    if (!empId) return;

    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`${BASE_URL}/get_empby_id/${empId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const result = await res.json();

      if (result.status && result.data.length > 0) {
        const first = result.data[0];
        setFormData(prev => ({
          ...prev,
          name: first.candidate_name,
          mobile: first.mobile,
        }));
        setDressList(result.data);
        setFormError(null);
      } else {
        setFormData(prev => ({ ...prev, name: '', mobile: '' }));
        setDressList([]);
        setFormError('No data found.');
      }
    } catch (err) {
      console.error(err);
      setFormError('Error fetching data.');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({ ...prev, [name]: value }));

  if (name === 'id') {
    setLoading(true);
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      fetchEmployeeDetails(value.trim());
    }, 500);
  }
};

const handleImageChange = (e) => {
  setFormData(prev => ({
    ...prev,
    image: e.target.files[0]
  }));
};

  const handleSubmit = async (e) => {
  e.preventDefault();
  const { id, name, mobile, utr_number, remarks, image } = formData;

  if (!id || !name || !mobile || !utr_number || !image) {
    setFormError('Please fill all required fields and upload image.');
    return;
  }

  try {
    const token = localStorage.getItem('authToken');
    const submission = new FormData();
        const formattedDateTime = new Date(dateTime).toISOString().slice(0, 19).replace("T", " ");

    submission.append('emp_id', id);
    submission.append('emp_name', name);
    submission.append('utr_number', utr_number);
    submission.append('remarks', remarks);
    submission.append('image', image);
    submission.append('date_time', formattedDateTime);

    const response = await fetch(`${BASE_URL}/backend_payment_update`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: submission,
    });

    const result = await response.json();

    if (result.status) {
      alert('Payment submitted successfully!');
      navigate('/manage_stocks');
    } else {
      setFormError(result.message || 'Submission failed');
    }
  } catch (error) {
    console.error(error);
    setFormError('Submission error');
  }
};

  const handleBackClick = () => navigate('/manage_stocks');

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  return (
    <div className="page-wrapper bg-light">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div
        className="page-container"
        style={{
          marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
          transition: 'margin-left 0.3s ease',
        }}
      >
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-12 col-lg-10">
                  <div className="card shadow-sm border-0 rounded-3">
                    <div className="card-header bg-primary text-white">
                      <h4 className="mb-0 text-uppercase">Payment Update</h4>
                    </div>
                    <div className="card-body p-4">
                      <form onSubmit={handleSubmit}>
                        {formError && (
                          <div className="alert alert-danger">{formError}</div>
                        )}

                        <div className="row">
                          <div className="col-12 col-md-4 mb-3">
                            <label className="form-label fw-semibold text-uppercase">ID</label>
                            <input
                              type="text"
                              className="form-control"
                              name="id"
                              value={formData.id}
                              onChange={handleInputChange}
                              placeholder="Enter Employee ID"
                            />
                          </div>
                          <div className="col-12 col-md-4 mb-3">
                            <label className="form-label fw-semibold text-uppercase">Name</label>
                            <input
                              type="text"
                              className="form-control bg-light"
                              name="name"
                              value={formData.name}
                              readOnly
                            />
                          </div>
                          <div className="col-12 col-md-4 mb-3">
                            <label className="form-label fw-semibold text-uppercase">Mobile</label>
                            <input
                              type="text"
                              className="form-control bg-light"
                              name="mobile"
                              value={formData.mobile}
                              readOnly
                            />
                          </div>
                        </div>

                        {loading && (
                          <div className="text-center my-3">
                            <Spinner animation="border" variant="primary" />
                          </div>
                        )}

                        {dressList.length > 0 && !loading && (
                          <>
                            <hr />
                            <h5 className="mb-3 text-uppercase">Dress Items</h5>
                            <div className="table-responsive">
                              <table className="table table-sm table-bordered table-hover table-striped align-middle text-center">
                                <thead className="table-dark">
                                  <tr>
                                    <th>#</th>
                                    <th>Dress Type</th>
                                    <th>Size</th>
                                    <th>Color</th>
                                    <th>Qty</th>
                                    <th>Area</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {dressList.map((item, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{item.dress_type}</td>
                                      <td>{item.dress_size}</td>
                                      <td>{item.dress_color}</td>
                                      <td>{item.uniform_qty}</td>
                                      <td>{item.area}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                          </>
                        )}

                        <div className="row">
  <div className="col-12 col-md-4 mb-3">
    <label className="form-label fw-semibold text-uppercase">UTR Number</label>
    <input
      type="text"
      className="form-control"
      name="utr_number"
      value={formData.utr_number}
      onChange={handleInputChange}
      placeholder="Enter UTR Number"
    />
  </div>

  <div className="col-12 col-md-4 mb-3">
    <label className="form-label fw-semibold text-uppercase">Remarks</label>
    <input
      type="text"
      className="form-control"
      name="remarks"
      value={formData.remarks}
      onChange={handleInputChange}
      placeholder="Enter Remarks"
    />
  </div>

  <div className="col-12 col-md-4 mb-3">
    <label className="form-label fw-semibold text-uppercase">Upload Image</label>
    <input
      type="file"
      className="form-control"
      accept="image/*"
      onChange={handleImageChange}
    />
  </div>

  <div className="col-12 col-md-4 mb-3">
  <label className="form-label fw-semibold text-uppercase">Date & Time</label>
  <input
    type="datetime-local"
    className="form-control"
    value={dateTime}
    onChange={handleDateTimeChange}
  />
</div>

</div>


                        <div className="d-flex justify-content-between mt-4">
                          <button
                            type="submit"
                            className="btn btn-success px-4"
                            disabled={loading}
                          >
                            Submit
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-secondary px-4"
                            onClick={handleBackClick}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="mt-4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default BackendPaymentUpdate;
